import React from 'react'
import { useLocation } from 'react-router'

import ErrorBoundary from 'components/error-boundary/ErrorBoundary'
import { ProjectContainer } from 'features/project/Container'
import useMixpanel from 'features/project/hooks/use-mixpanel'
import { ProjectLayout } from 'features/project/partials/project-layout/ProjectLayout'
import {
  ProjectFilterListOwnerContext,
  useProjectFilterList,
} from 'src/hooks/use-project-filter-list'

type Props = { projectId: string }

// Readiness is owned by ProjectRoot (the single bootstrap gate). By the time
// this renders, all required project data is guaranteed present. The hooks
// below run for their side effects (mixpanel, filter-list prefetch).
export const AvailableProjectRoot: React.FC<Props> = ({ projectId }) => {
  const location = useLocation()
  useMixpanel()
  useProjectFilterList(projectId)

  return (
    <ProjectFilterListOwnerContext.Provider value={projectId}>
      <ProjectLayout>
        <ErrorBoundary resetKey={location.pathname}>
          <ProjectContainer />
        </ErrorBoundary>
      </ProjectLayout>
    </ProjectFilterListOwnerContext.Provider>
  )
}
